































import { Component, Vue } from "vue-property-decorator";
import DevByDay from "./DevByDay.vue";
import DancerByNight from "./DancerByNight.vue";
import Programmer from "./Programmer.vue";
import LightSwitch from "./LightSwitch.vue";
import Blog from "@/components/Blog";

@Component({
  components: {
    DancerByNight,
    DevByDay,
    LightSwitch
  }
})
export default class About extends Vue {
  isDay = true;

  toggleDay() {
    this.isDay = !this.isDay;
  }
}
